import React, { useEffect, useState } from 'react';
import { isGuestAllowed, isLoggedIn, touchSession } from '../utils/session';
import GuestConfirmDialog from './GuestConfirmDialog';

// 演習画面の入口。番号を選んでいれば（または「番号なしで進める」を選んだタブなら）そのまま開く。
// 番号が無いときは確認モーダルを出し、「そのまま進める」なら番号なしで演習を開く
// （2026-10-10変更。旧：ログイン必須でログイン画面へ送っていた）。
// Home の演習ボタンでも同じモーダルを先に出すので、ここに来るのは演習URLを直接開いたときだけ。
function RequireLogin({ children }) {
  const loggedIn = isLoggedIn();
  const [allowed, setAllowed] = useState(() => loggedIn || isGuestAllowed());

  useEffect(() => {
    if (loggedIn) touchSession();
  }, [loggedIn]);

  if (!allowed) {
    return <div className="page"><GuestConfirmDialog onProceed={() => setAllowed(true)} /></div>;
  }
  return children;
}

export default RequireLogin;
